import { useContext } from 'react';
import { Box, Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import LogoutIcon from '@mui/icons-material/Logout';
import userContext from '../context/userContext';
import { useNavigate } from "react-router-dom";

const LogItem = ({user,  navToLogin, logout, navToReg}) =>{
    
    if (user) {
        return (
            <ListItem disablePadding>
            <ListItemButton onClick={logout}>
              <ListItemIcon>
                <LogoutIcon/>
              </ListItemIcon>
              <ListItemText primary={"Logout"} />
            </ListItemButton>
          </ListItem>
        )
    }
    return (
        <>
        <ListItem disablePadding>
            <ListItemButton onClick={navToLogin}>
            <ListItemIcon>
                <LoginIcon/>
            </ListItemIcon>
            <ListItemText primary={"Login"} />
            </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
        <ListItemButton  onClick={navToReg}>
            <ListItemIcon>
            <PersonAddIcon/>
            </ListItemIcon>
            <ListItemText primary={"Register"} />
        </ListItemButton>
        </ListItem>
    </>
    )    
}
export default function TemporaryDrawer({open, setOpen}) {
    const { user, setUserStore } = useContext(userContext);
    const navigate = useNavigate();
    const navToLogin = () => {
        navigate('/login')
    }
    const logout = () => {
        console.log('logout')
        setUserStore(null)
        setOpen(false)
        navigate('/')
    }
    const navToReg = () => {
        navigate('/register')
    }
  const DrawerList = (
    <Box sx={{ width: 250, mt: 10 }} role="presentation">
        {user && (<Typography sx={{textAlign:'center'}}>Hey {user?.user?.name}</Typography>)}
      <List>
          <LogItem user={user} navToLogin={navToLogin} logout={logout} navToReg={navToReg}/>
      </List>
    </Box>
  );

  return (
    <div>
      <Drawer open={open} onClose={ ()=> { setOpen(false)}} >
        {DrawerList}
      </Drawer>
    </div>
  );
}